import AbstractRuleSpecification from 'kaspi.frontend/src/modules/ruleSpecification/AbstractRuleSpecification'

export default class IsResponseNotAuthorized extends AbstractRuleSpecification {
  constructor () {
    super()

    this._reasonNotSatisfied = 'Вы не авторизованы'
  }

  _executeCheckIsSatisfiedBy (response) {
    return response.status === 401
  }
}
